import { gql } from '@apollo/client';

export const GET_ACCOUNT_ADDRESSES = gql`
  query GetPrimaryAddressesByAccount($accountId: ID!) {
    primaryAddresses(accountId: $accountId) {
      edges {
        node {
          id
          city
          stateProvince
          zipPostalCode
          countryRegion

          # Address 1 fields
          address1
          address1Street1
          address1Street2
          address1Street3
          address1County
          address1Latitude
          address1Longitude

          # Address 2 fields
          address2
          address2Street1
          address2Street2
          address2Street3
          address2City
          address2StateProvince
          address2ZipPostalCode
          address2CountryRegion

          # Contact fields
          businessPhone
          fax
        }
      }
    }
  }
`;

export interface AccountAddressesData {
  address1: AddressData;
  address2: AddressData;
}

// UI Data Types
export interface AddressData {
  address: string;
  businessPhone: string;
  city: string;
  countryRegion: string;
  county: string;
  fax: string;
  id: string;
  latitude: string;
  longitude: string;
  stateProvince: string;
  street1: string;
  street2: string;
  street3: string;
  zipPostalCode: string;
}

export interface GetAccountAddressesData {
  primaryAddresses: {
    edges: {
      node: PrimaryAddressNode;
    }[];
  };
}

export interface GetAccountAddressesVariables {
  accountId: string;
}

// GraphQL Response Types
export interface PrimaryAddressNode {
  address1?: null | string;
  address1County?: null | string;
  address1Latitude?: null | string;
  address1Longitude?: null | string;
  address1Street1?: null | string;
  address1Street2?: null | string;
  address1Street3?: null | string;
  address2?: null | string;
  address2City?: null | string;
  address2CountryRegion?: null | string;
  address2StateProvince?: null | string;
  address2Street1?: null | string;
  address2Street2?: null | string;
  address2Street3?: null | string;
  address2ZipPostalCode?: null | string;
  businessPhone?: null | string;
  city?: null | string;
  countryRegion?: null | string;
  fax?: null | string;
  id: string;
  stateProvince?: null | string;
  zipPostalCode?: null | string;
}

export function createEmptyAccountAddressesData(): AccountAddressesData {
  const emptyAddress: AddressData = {
    address: '',
    businessPhone: '',
    city: '',
    countryRegion: '',
    county: '',
    fax: '',
    id: '',
    latitude: '',
    longitude: '',
    stateProvince: '',
    street1: '',
    street2: '',
    street3: '',
    zipPostalCode: ''
  };

  return {
    address1: { ...emptyAddress },
    address2: { ...emptyAddress }
  };
}

// Mapper
export function mapAccountAddresses(
  node: PrimaryAddressNode
): AccountAddressesData {
  return {
    address1: {
      address: node.address1 ?? '',
      businessPhone: node.businessPhone ?? '',
      city: node.city ?? '',
      countryRegion: node.countryRegion ?? '',
      county: node.address1County ?? '',
      fax: node.fax ?? '',
      id: node.id,
      latitude: node.address1Latitude ?? '',
      longitude: node.address1Longitude ?? '',
      stateProvince: node.stateProvince ?? '',
      street1: node.address1Street1 ?? '',
      street2: node.address1Street2 ?? '',
      street3: node.address1Street3 ?? '',
      zipPostalCode: node.zipPostalCode ?? ''
    },
    address2: {
      address: node.address2 ?? '',
      businessPhone: '',
      city: node.address2City ?? '',
      countryRegion: node.address2CountryRegion ?? '',
      county: '',
      fax: '',
      id: node.id,
      latitude: '',
      longitude: '',
      stateProvince: node.address2StateProvince ?? '',
      street1: node.address2Street1 ?? '',
      street2: node.address2Street2 ?? '',
      street3: node.address2Street3 ?? '',
      zipPostalCode: node.address2ZipPostalCode ?? ''
    }
  };
}
